import React from "react";

function ReportIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 22.207 29.22">
      <path
        d="M21.99,11.169h6.647A.362.362,0,0,0,29,10.8h0a2.162,2.162,0,0,0-.782-1.673L22.647,4.485a2.346,2.346,0,0,0-1.5-.541h0a.539.539,0,0,0-.541.541v5.3A1.387,1.387,0,0,0,21.99,11.169Z"
        transform="translate(-6.795 -3.937)"
      />
      <path
        d="M19.22,9.781V3.937H9.65A2.344,2.344,0,0,0,7.313,6.275V30.82A2.344,2.344,0,0,0,9.65,33.157H27.182A2.344,2.344,0,0,0,29.52,30.82V13.069H22.507A3.292,3.292,0,0,1,19.22,9.781Z"
        transform="translate(-7.313 -3.937)"
      />
    </svg>
  );
}

export { ReportIcon };
